import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Tooltip, Icon } from "antd";
import { TemplateModel } from "../../../../stores/TemplateModel";

interface Props extends RouteComponentProps<any> {
  template: TemplateModel;
}

class EditTemplateAction extends React.PureComponent<Props, any> {
  render() {
    const { template } = this.props;
    return (
      <>
        <Tooltip placement="bottom" title={"Edit"}>
          <button
            onClick={async () => {
              this.props.history.push(`templates/${template.id}/edit`);
              //viewStore.showView("template", { id: template.id });
            }}
          >
            <Icon type="edit" />
          </button>
        </Tooltip>
      </>
    );
  }
}
export default withRouter(EditTemplateAction);
